import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-google-map',
    templateUrl: './app-google-map.component.html',
    styleUrls: ['./app-google-map.component.scss'],
    standalone: false
})
export class GoogleMapComponent {
    @Input() addresses!: any;
    markers = [];
    center: google.maps.LatLngLiteral;
    zoom = 14;

    ngOnInit() {
        this.generateMarkers(this.addresses);
    }

    generateMarkers(addresses: any[]) {
        const geocoder = new google.maps.Geocoder();
        addresses.forEach((address, index) => {
            const geoCodePayload: google.maps.GeocoderRequest = {
                address: address,
                componentRestrictions: {
                    country: 'CH'
                }
            };
            geocoder.geocode(geoCodePayload, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    const newPosition: google.maps.LatLngLiteral = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    };
                    this.markers.push({
                        position: newPosition,
                        label: String.fromCharCode(65 + index), // Generate pointer labels A, B, C...
                        title: address
                    });

                    // Adjust the map center to the first location
                    if (index === 0) {
                        this.center = newPosition;
                    }
                } else {
                    console.error('Geocode was not successful for the following reason:', status);
                }
            });
        });
    }
}
